import React, { useEffect } from "react";
import "./Resorts.css";
import { Container, Row, Col, Card, Badge } from "react-bootstrap";
import resort_1 from "../assets/resort_1.jpg";
import { FaSwimmingPool, FaSpa, FaChild, FaLeaf, FaHome, FaShieldAlt, FaUtensils, FaTree } from "react-icons/fa";
import { FaMapMarkedAlt, FaCouch, FaSuitcaseRolling, FaUserTie } from "react-icons/fa"

const resortsData = [
  {
    name: "Serene Retreat",
    location: "Shadnagar, Hyderabad",
    image:
      "https://tse1.mm.bing.net/th/id/OIP.E93sgQBVzNxe-dQErP3R1gHaEO?r=0&rs=1&pid=ImgDetMain&o=7&rm=3",
    description:
      "A peaceful luxury resort surrounded by greenery and modern amenities.",
  },
  {
    name: "Green Valley Resort",
    location: "Kondapur, Telangana",
    image:
      "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80",
    description:
      "Experience comfort and nature at this family-friendly countryside resort.",
  },
  {
    name: "Sunset Bliss",
    location: "Vikarabad Hills",
    image:
      "https://heybairtender.s3.amazonaws.com/recipes/sunset-citrus-spritz2324.png",
    description:
      "Luxury resort with sunset views and private pools near the hills.",
  },
];
const featureCards = [
  { icon: <FaSwimmingPool />, title: "Private Pool" },
  { icon: <FaSpa />, title: "Spa & Wellness" },
  { icon: <FaChild />, title: "Kids Play Area" },
  { icon: <FaLeaf />, title: "Nature Trails" },
  { icon: <FaHome />, title: "Luxury Villas" },
  { icon: <FaShieldAlt />, title: "24/7 Security" },
  { icon: <FaUtensils />, title: "Restaurant & Lounge" },
  { icon: <FaTree />, title: "Event Lawn" },
];
const ResortsOverview = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="resorts-page">
      {/* Header */}
      <div className="resorts-header">
        <div className="resort-image-wrapper">
          <img src={resort_1} alt="Resort" className="resort-image" />
        </div>

        <div className="resort-text">
          <h1>Nandanam Resorts</h1>
          <p>Discover comfort and nature at our exclusive resort locations</p>
        </div>
      </div>

      {/* Resorts Overview Grid */}
      <Container className="my-5">
        <Row>
          {resortsData.map((resort, index) => (
            <Col md={4} sm={6} key={index} className="mb-4">
              <Card className="resort-card h-100 shadow-sm">
                <Card.Img variant="top" src={resort.image} alt={resort.name} />
                <Card.Body>
                  <Card.Title>{resort.name}</Card.Title>
                  <Card.Subtitle className="mb-2 text-muted">
                    {resort.location}
                  </Card.Subtitle>
                  <Card.Text>{resort.description}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

      {/* Slide Image */}
      <div className="resorts_slide-4">
  <div className="left-large-image">
    <img
      src="https://s3.amazonaws.com/vrp2/vrpimages/253/1/315/63651bf9f0490_F3EF6641_4F27_494C_B4E2_3A2FCF24813D_1_105_c.jpeg"
      alt="Serene Retreat"
    />
  </div>

  <div className="right-small-images">
    <img
      src="https://cache.marriott.com/marriottassets/marriott/SJDLC/sjdlc-guest-room-8088-hor-clsc.jpg?interpolation=progressive-bilinear&"
      alt="Resort Room"
    />
    <img
      src="https://q-xx.bstatic.com/xdata/images/hotel/max1024x768/490855977.jpg?k=23f7c3797954452857194a8fb8bce66333ad5226b2c96d383eedb8d8742e60f6&o="
      alt="Resort Exterior"
    />
  </div>
</div>


      {/* Features Section */}
    <section className="description-section py-5">
  <Container>
    <Row>
      <Col md={6}>
        <h4 className="text-success">About Serene Retreat</h4>
        <p>
          Nestled amidst lush greenery in Shadnagar, Serene Retreat offers
          an escape into luxury and nature. Designed for families, couples,
          and groups, this premium resort combines elegant architecture
          with eco-conscious living.
        </p>
        <p>
          From rejuvenating spa sessions to serene nature walks, every
          moment here is crafted for peace and comfort. Our private villas
          and world-class amenities ensure a truly immersive stay
          experience.
        </p>
      </Col>
      <Col md={6}>
        <h4 className="text-success">Why Choose Us</h4>
        <ul className="highlight-list list-unstyled">
          <li className="d-flex align-items-start mb-2">
            <FaMapMarkedAlt className="me-2 text-success mt-1" />
            Strategic location with easy highway access
          </li>
          <li className="d-flex align-items-start mb-2">
            <FaCouch className="me-2 text-success mt-1" />
            Premium interiors and designer landscapes
          </li>
          <li className="d-flex align-items-start mb-2">
            <FaSuitcaseRolling className="me-2 text-success mt-1" />
            Ideal for weekend getaways and corporate retreats
          </li>
          <li className="d-flex align-items-start mb-2">
            <FaLeaf className="me-2 text-success mt-1" />
            100% eco-friendly construction
          </li>
          <li className="d-flex align-items-start mb-2">
            <FaUserTie className="me-2 text-success mt-1" />
            Staff trained in hospitality excellence
          </li>
        </ul>
      </Col>
    </Row>
  </Container>
</section>

    </div>
  );
};

export default ResortsOverview;
